import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfirmationService } from 'primeng/api';
import { IClient, IClientOutlet } from 'src/app/core/models';
import { ClientService, MenuService } from 'src/app/core/services';
import { CommonConstants } from '../../constant';

@Component({
  selector: 'ic-outlet-info',
  templateUrl: './outlet-info.component.html',
  styleUrls: ['./outlet-info.component.scss'],
})
export class OutletInfoComponent implements OnInit {
  public clientConfig: IClient;
  public deliveryType = CommonConstants.DeliveryType;
  public isMobile: boolean = false;
  public outlet: IClientOutlet;

  constructor(
    private readonly clientService: ClientService,
    private readonly router: Router,
    private readonly confirmationService: ConfirmationService,
    private readonly menuService: MenuService,
    private readonly deviceService: DeviceDetectorService
  ) {
    this.clientConfig = this.clientService.currentClientValue;
    this.outlet = this.clientConfig.outlet;
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit(): void {
    this.clientService.isOutletSelected.subscribe((outletSelected) => {
      if (outletSelected) {
        this.outlet = this.clientService.currentClientValue?.outlet;
      }
    });

    this.clientService.currentClient.subscribe((client) => {
      this.clientConfig = client;
    });
  }

  startOver() {
    const cart = this.menuService.getCart();
    if (cart && cart.length > 0) {
      this.confirmationService.confirm({
        message:
          'Your cart contains items. Do you want to discard the selection?',
        accept: () => {
          this.router.navigate(['/home']);
        },
      });
    } else {
      this.router.navigate(['/home']);
    }
  }
}
